<template>
  <div class="bg">
    <!-- 戻る -->
    <el-button style="display:block;" class="back" @click="to_login">{{ $t('COMMON.BTN_BACK') }}</el-button>
  </div>
</template>
<script>
import css from "@/statics/css"
let url = require("@/../config/sysConfig")
export default {
  mixins: [css],
  data() {
    return {
      imgUrl: require("../../statics/images/error.png"),
    };
  },
  methods: {
    to_login: function () {
      var vm = this;
      //this.$router.push({ path: "/login"});
      window.location.reload(true);
    }
  },
  created() {
    this.close_loading()
  }
}

</script>
<style>
.bg {
  background-image: url(../../statics/images/error.png);
  background-size: 99% 99%;
  width: 100%;
  height: 96vh;
  min-width: 260px;
  min-height: 280px;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  box-shadow: 1px 2px 20px 2px #156264;
  border: solid 1px #999999;
}

.back {
  color: #23b2e8;
  font-weight: bold;
  font-size: 15pt;
  margin: auto;
  width: 100px;
  margin-top: 45%;
}
</style>


// WEBPACK FOOTER //
// src/components/page/error.vue